<template>
    <b-card>
      <CorrespondenceThreadsTable/>
    </b-card>
</template>

<script>
import CorrespondenceThreadsTable from '@/components/Dashboard/Views/excmcorrespondence/CorrespondenceThreadsTable'

export default {
  name: 'CorrespondenceThreadsList',
  components: {
    CorrespondenceThreadsTable
  },
  created () {
  },
  methods: {
  }
}
</script>
